import { notificationsService } from "@/services/notificationsService";
import { chatService } from "@/services/chatService";

/**
 * Update user avatar
 */
export const updateUserAvatar = async (
  userId: string,
  newAvatarUrl: string
): Promise<boolean> => {
  console.log(`Updating avatar for user ${userId} to ${newAvatarUrl}`);
  try {
    const uploadsService = await import("@/services/uploadsService");
    await uploadsService.uploadsService.uploadAvatar(newAvatarUrl);
    return true;
  } catch (error) {
    console.error("Failed to update avatar:", error);
    return false;
  }
};

/**
 * Send a nudge to a team member
 */
export const sendChatNudge = async (
  recipientId: string,
  senderId: string,
  senderName: string
): Promise<boolean> => {
  try {
    await notificationsService.createNotification({
      userId: recipientId,
      type: "nudge",
      title: "New Nudge",
      message: `${senderName} sent you a nudge to connect!`,
      data: { type: "nudge", fromUserId: senderId },
      actionUrl: "/checkin",
    });

    return true;
  } catch (error) {
    console.error("Error sending nudge:", error);
    return false;
  }
};

/**
 * Get conversations for the current user
 */
export const getConversations = async () => {
  try {
    const response = await chatService.getChats();
    // API returns data directly
    return Array.isArray(response) ? response : (response?.chats || []);
  } catch (error) {
    console.error("Failed to get conversations:", error);
    return [];
  }
};

/**
 * Send a message to a chat
 */
export const sendMessage = async (chatId: string, message: string) => {
  console.log(`Sending message to chat ${chatId}: ${message}`);
  try {
    await chatService.sendMessage(chatId, { content: message });
    return true;
  } catch (error) {
    console.error("Failed to send message:", error);
    return false;
  }
};
